import { useGetList, useListContext } from "ra-core";
import { Badge } from "@/components/ui/badge";
import { ActiveFilterButton } from "./ActiveFilterButton";
import type { Tag } from "../types";

export function TagFilterSummary() {
  const { data: tags = [] } = useGetList<Tag>("tags", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" },
  });
  const { filterValues } = useListContext();
  if (!Object.keys(filterValues ?? {}).some((key) => key !== "q")) return null;
  return (
    <div className="mb-4 flex flex-wrap gap-1">
      {tags.map((tag) => (
        <ActiveFilterButton
          key={tag.id}
          className="h-8 w-auto justify-between"
          label={
            <Badge
              variant="secondary"
              className="cursor-pointer text-sm font-normal rovero-colored-tag text-[#482719]"
              style={{ backgroundColor: tag.color }}
            >
              {tag.name}
            </Badge>
          }
          value={{ "tags@cs": `{${tag.id}}` }}
        />
      ))}
    </div>
  );
}
